module.exports = __webpack_public_path__ + "images/stickers/pete-sketch.d810919ee99918a69380.png";